@if (event?.field_icon) {
  <img [src]="publicFilesURL + event.field_icon" width="40">
} @else {
  <app-svg-icon
    class="icon"
    [src]="'icons/40/' + type + '.svg'"
    [svgStyle]="{ 'width.px': '40', 'height.px': '40' }"
  ></app-svg-icon>
}


<div class="dashboard-card__text">
  <div class="card-title">{{ title }}</div>
  @if (type === DashboardCardType.Event) {
    <ng-container
      [ngTemplateOutlet]="eventCard"
    ></ng-container>
  }
  @if (type === DashboardCardType.MediFinder || type === DashboardCardType.Voucher) {
    <ng-container
      [ngTemplateOutlet]="mediFinderCard"
    ></ng-container>
  }
</div>

<ng-template #defaultCard>
  <div class="card-title">{{ title }}</div>
</ng-template>

<ng-template #eventCard>
  @if (event.field_start_date && event.field_end_date) {
    <div class="caption">Programm {{ event.field_location }} {{ event.field_start_date | date:dateTimeEvent }} bis {{ event.field_end_date | date:dateTimeEvent }}</div>
  }
  @if (event.field_freetext) {
    <div class="caption freetext" [innerHTML]="event.field_freetext"></div>
  }
</ng-template>

<ng-template #mediFinderCard>
  <div class="caption freetext" [innerHTML]="text"></div>
</ng-template>
